import React, { useState, useEffect } from 'react';

const DateSelector = ({
  dateList, 
  card_sensor_data,
  form_graph_selected_date,
  t_graph_update_graph_selectedDate_by_devId_and_sensorId,  
  dev_id, 
  sensor_id,
  t_update_request_graph_by_devId_and_sensorId,
  t_update_request_graph_rx_data
  }) => {

  const [selectedDate, setSelectedDate] = useState(dateList[0]);
  const [isCustomDate, setIsCustomDate] = useState(false);

  useEffect(() => {
    t_graph_update_graph_selectedDate_by_devId_and_sensorId(dateList[0], dev_id, sensor_id)
  }, [])

  const fieldsQty = () => {
    const fields = []
    card_sensor_data.forEach((card) => {
      if (!card.form_sensor_field_ignore) fields.push(card.db_field);
    });
    
    return fields.length;
  }

  //console.log('fieldsQty: ', fieldsQty())

  const dates1 = [
    '2024-01-01',
    '2024-01-02',
    '2024-01-03',
    '2024-01-04',
    '2024-01-05',
    '2024-01-06',
    '2024-01-07',
    '2024-01-08',
    '2024-01-09',
    '2024-01-10',
  ];
  //const dates = [];
  //console.log(typeof(dateList))
  //artray or 0 test
  const dates = typeof(dateList) === "object" ? dateList : []
  //const dates = dateList;

  const handleSubmit = (event) => {
    event.preventDefault();
    // test necessiary for fields qty check
    if (fieldsQty() === 0) return; 

    // Handle form submission logic here
    t_graph_update_graph_selectedDate_by_devId_and_sensorId(selectedDate, dev_id, sensor_id)
    t_update_request_graph_by_devId_and_sensorId(dev_id, sensor_id)
    t_update_request_graph_rx_data()
    //console.log('Selected date submitted:', selectedDate);
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    //console.log(value, selectedDate)
    setSelectedDate(value);
    setIsCustomDate(value === 'custom');
    //t_graph_update_graph_selectedDate_by_devId_and_sensorId(value, dev_id, sensor_id)
  };

   //console.log(card_sensor_data, form_graph_selected_date)
  return (
    <form className="form-inline" onSubmit={handleSubmit}>
      <div className="form-group mx-sm-3 mb-2">
        <label htmlFor="dateSelect" className="sr-only">Select or Enter Date</label>
        <select
          id="dateSelect"
          className="form-control"
          value={isCustomDate ? 'custom' : selectedDate}
          onChange={handleSelectChange}
        >
          <option value="" disabled>Select a date</option>
          {dates.map((date) => (
            <option key={date} value={date}>
              {date}
            </option>
          ))}
          <option value="custom">Custom Date</option>
        </select>
      </div>
      {isCustomDate && (
        <div className="form-group mx-sm-3 mb-2">
          <label htmlFor="customDateInput" className="sr-only">Custom Date</label>
          <input
            type="date"
            id="customDateInput"
            className="form-control"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>
      )}
      <button type="submit" className={`btn btn-secondary mb-2 ' + ${fieldsQty() === 0 ? 'disabled': ''} `} aria-pressed="false">Make Graph</button>
    </form>
  );
};

export default DateSelector;